import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import Link from 'react-router/lib/Link';

import Card from '../../Card';
import Icon from '../../Icon';
import Badge from '../../Badge';
import SimpleAvatar from '../SimpleAvatar';
import { actions as uiDrawerActions } from '../../../redux/ui/drawer';
import { isDesktop } from '../../../utils/mobileHelpers';
import { COLORS } from '../../../constants/styles';

import styles from './index.styl';

const NavItem = ({
  avatar,
  avatarUrl,
  className,
  href,
  icon,
  onClick,
  title,
  subtitle,
  toggleDrawerVisibility,
  active,
  waiting,
  counter,
  unverified,
  withGreyHover,
  ...other
}) => {
  const clickHandler = () => {
    if (onClick) {
      onClick();
      return false;
    }
    if (!isDesktop()) {
      toggleDrawerVisibility();
    }

    return false;
  };

  const asset = avatar ? (
    <SimpleAvatar
      src={avatarUrl}
      text={title}
      size={40}
      waiting={waiting}
      disabled={unverified}
      unverified={unverified}
    />
  ) : (
    <Icon name={icon} size={24} style={{ fill: COLORS.white }} />
  );

  return (
    <div>
      <Link
        to={href && `/${href}`}
        styleName={classNames('navLink', {
          'navLink--active': active,
          grey: withGreyHover,
        })}
        activeClassName={styles['navLink--active']}
        onClick={clickHandler}
        {...other}
      >
        <Card
          withGreyHover
          additionalContent={{
            left: asset,
            right: counter && <Badge text={counter} />,
          }}
          className={classNames('pa2', className)}
          text={{
            primary: title,
            complementary: subtitle,
          }}
        />
      </Link>
    </div>
  );
};

NavItem.propTypes = {
  avatar: PropTypes.bool,
  avatarUrl: PropTypes.string,
  className: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  toggleDrawerVisibility: PropTypes.func,
  active: PropTypes.bool,
  waiting: PropTypes.bool,
  unverified: PropTypes.bool,
  counter: PropTypes.number,
  withGreyHover: PropTypes.bool,
};

const mapDispatchToProps = {
  toggleDrawerVisibility: uiDrawerActions.toggleVisibility,
};

export default connect(
  null,
  mapDispatchToProps,
)(CSSModules(NavItem, styles, { allowMultiple: true }));



// WEBPACK FOOTER //
// ./src/components/common/NavItem/index.jsx